/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字
 * @param {规则}} format 例子：
 * (new Date()).Format('yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
 * (new Date()).Format('yyyy-M-d h:m:s.S')      ==> 2006-7-2 8:9:4.18
 */
export const dateFormat = function(format, date) {
  if (!date) {
    date = new Date();
  }
  var o = {
    'M+': date.getMonth() + 1,               // 月份
    'd+': date.getDate(),                    // 日
    'h+': date.getHours(),                   // 小时
    'm+': date.getMinutes(),                 // 分
    's+': date.getSeconds(),                 // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds()             // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return format;
}

/**
 * 判断是否折扣，例如：0.95  0.75 0.5
 */
export const vaildDiscount = function(value) {
  if (value > 1 || value < 0.01) {
    return '折扣必须在0.01和1之间';
  }
  var reg = /^[0-9]+([.]{1}[0-9]{1,2})?$/;
  if (!reg.test(value)) {
    return '折扣格式错误，95折：0.95  7折：0.7';
  }
  return true;
}

/**
 * 查询条件组装为 sq_clumnname_op 的对象
 */
export const bindQuery = function(query, queryOpMap, excludes) {
  excludes = excludes || ['orders', 'fields', 'page_no', 'page_size']
  const newQuery = {};
  queryOpMap = queryOpMap || {};
  Object.keys(query).forEach(function(key) {
    if (excludes.indexOf(key) > -1) {
      newQuery[key] = query[key]
    } else if (queryOpMap[key]) {
      const ops = queryOpMap[key].split('|')
      if (ops.length === 1) {
        newQuery['sp_' + key + '_' + queryOpMap[key]] = query[key]
      } else {
        // 如果是时间区间的查询
        // 例如：created是个数组，0起始时间 1截止时间 对应的op为 le|ge，一一对应
        if (typeof query[key] === 'object') {
          for (let i = 0; i < ops.length; i++) {
            newQuery['sp_' + key + '_' + ops[i]] = query[key][i]
          }
        } else {
          for (let i = 0; i < ops.length; i++) {
            newQuery['sp_' + key + '_' + ops[i]] = query[key]
          }
        }
      }
    } else {
      newQuery['sp_' + key + '_eq'] = query[key]
    }
  })
  return newQuery;
}

/**
 * 缩略图工具
 */
export const thumb = function(url, width, height) {
  if (!url) {
    return '';
  }
  if (!width || !height) {
    return url;
  }
  const urlArr = url.split('.');
  const len = urlArr.length;
  let newUrl = '';
  const suffixArr = [
    'jpg', 'jpeg', 'png', 'gif'
  ]
  if (suffixArr.indexOf(urlArr[len - 1]) === -1) {
    return url;
  }
  for (const i in urlArr) {
    if (Number(i) === (len - 1) && suffixArr.indexOf(urlArr[i].toLowerCase()) > -1) {
      newUrl += '_' + width + 'x' + height + '.' + urlArr[i];
    } else if (Number(i) === 0) {
      newUrl += urlArr[i];
    } else {
      newUrl += '.' + urlArr[i];
    }
  }
  return newUrl;
}

/**
  * 参数说明：
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
*/
export const numberFormat = function(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number

  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  const sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep
  const dec = (typeof dec_point === 'undefined') ? '.' : dec_point
  let s = ''
  const toFixedFix = function(n, prec) {
    var k = Math.pow(10, prec);
    return '' + Math.floor(n * k) / k;
  };
  s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2');
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}




// WEBPACK FOOTER //
// ./src/utils/util.js